import React, { useEffect, useRef } from 'react';
import { Dialog, DialogContent, Typography } from '@mui/material';
import ReactPlayer from 'react-player';

const VideoDetails = ({ open, setOpen, responseDetails }) => {
    const playerRef = useRef(null);

    useEffect(() => {
        const handleVisibilityChange = async () => {
            if (document.hidden && playerRef.current) {
                const videoElement = playerRef.current.getInternalPlayer();
                if (videoElement && document.pictureInPictureEnabled && !document.pictureInPictureElement) {
                    try {
                        await videoElement.requestPictureInPicture();
                    } catch (error) {
                        console.error("Error enabling PiP:", error);
                    }
                }
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    return (
        <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
            <DialogContent>
                {responseDetails?.videoPath ? (
                    <div style={{ position: 'relative', paddingTop: '56.25%' }}> {/* Aspect ratio 16:9 */}
                        <ReactPlayer
                            ref={playerRef}
                            url={responseDetails.videoPath}
                            controls
                            playing={false}
                            width="100%"
                            height="100%"
                            style={{ position: 'absolute', top: 0, left: 0 }}
                            config={{
                                file: {
                                    attributes: {
                                        controlsList: "nodownload",
                                        disablePictureInPicture: false
                                    }
                                }
                            }}
                        />
                    </div>
                ) : (
                    <Typography color="error">No video available</Typography>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default VideoDetails;
